import { BaseRequest } from "./baseRequest";

export class ConfGraphicsRequest extends BaseRequest {  
  confSessionId?: number;
  configurationId?: number;
  fileType?: string;
  graphicsPanelId?: number;
  graphicType?: number;
  graphicModes?: Array<number>;
}